<template>
    <el-dialog title="历史温度" :visible.sync="show" top='4.45rem' width="50%" @close="close">
        <div id="lineChart"></div>
    </el-dialog>
</template>

<script>

export default {
    props: {
        isShow: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            show: false
        }
    },
    watch: {
        isShow(n) {
            if (n) {
                this.$nextTick(() => {
                    // this.initChart()
                    const data = [
                        { title: '最高温度', label: ['2023-01', '2023-2', '2023-3', '2023-4', '2023-5', '2023-6', '2023-7'], value: [1, 21, 31, 49, 51, 69, 7], },
                        { title: '最低温度', label: ['2023-01', '2023-2', '2023-3', '2023-4', '2023-5', '2023-6', '2023-7'], value: [10, 22, 39, 4, 5, 6, 7], },
                        { title: '平均温度', label: ['2023-01', '2023-2', '2023-3', '2023-4', '2023-5', '2023-6', '2023-7'], value: [56, 42, 69, 41, 5, 6, 71], },
                    ]
                    this.setLineData(data, 'lineChart')

                })
            }
            this.show = n
            console.log(n)
        }
    },
    created() {


    },
    methods: {
        close() {
            console.log(111)
            // console.log(this.$parent)
            // this.$parent.isShow=false
            this.$emit('close')
        },
        setLineData(data, dom) {
            const colors = ['#00FEFF', '#1B7EF2', '#FF4083'];
            const legend = [];
            const series = [];
            let xAxis = [];
            data.forEach((item, index) => {
                legend.push({
                    name: item.title,
                    textStyle: { color: colors[index] },
                    icon: 'rect',
                    itemWidth: 4,
                    itemhight: 4,
                })
                xAxis = item.label
                series.push({
                    name: item.title,
                    smooth: true,
                    showSymbol: false,
                    type: "line",
                    lineStyle: {
                        width: 2,
                    },
                    color: colors[index],
                    data: item.value,
                })
            })
            const line = {
                dom,
                xAxis,
                legend: {
                    data: legend,
                    // x: 'right',
                    // y: 'top',
                    top: "6%",
                    right: "4%",
                    itemWidth: 10,
                    itemHeight: 2,
                    padding: [10, 0, 0, 0],
                },
                series: series
            }
            this.lineChart(line)
        },
        lineChart(data) {
            var linechart = this.$echarts.init(document.getElementById(data.dom))
            // 隐藏动画加载效果。
            var option = {
                color: ['#106BDC', '#0EDAE2', '#5931FC'],
                tooltip: {
                    trigger: 'axis',
                    // formatter: function (params) {
                    //     // console.log(params, 'params');
                    //     // return `<p>
                    //     //           <span style="color: #FFF; font-size: 14px; font-weight: normal;">监管笔数${params.name
                    //     //     }： ${params.data.account || 0} </span>

                    //     //       </p>`;
                    //     return `
                    //     <p style="font-size: 14px; font-weight: normal;">${params[0].name
                    //         }</p><br/>
                    //      <p>
                    //     <p style="font-size: 14px; font-weight: normal;">${params[0].value + '家'
                    //         }</p>
                    //      `;
                    //     // return params.name
                    // },
                    padding: [5, 20],
                    backgroundColor: 'rgba(255,255,255,0.8)',
                    // borderColor: 'rgba(18, 36, 132, 1)',
                    borderColor: '#292929',
                    borderWidth: 1,
                    textStyle: {
                        color: '#050F37',
                    },
                },
                legend: data.legend,
                grid: {
                    top: '25%',
                    left: '3%',
                    right: '3%',
                    bottom: '10%',
                    containLabel: true,
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: true,
                    axisLabel: {
                        color: '#00FEFF',
                        rotate: 30,
                        // interval: 'auto',
                        // textStyle: {
                        //     fontSize: 12
                        // },
                    },
                    axisLine: {
                        show: true, // X轴 网格线 颜色类型的修改
                        lineStyle: {
                            color: '#075F73',
                        },
                    },
                    axisTick: {
                        // X轴线 刻度线
                        show: true,
                        inside: true,
                        alignWithLabel: true
                    },
                    data: data.xAxis,
                },
                yAxis: {
                    name: '单位：℃',
                    nameTextStyle: {
                        color: '#00FEFF',
                        padding: [3, 0, 0, 0],
                        lineHeight: 60,
                        // align:'left'
                    },
                    // nameLocation:'end',
                    type: 'value',
                    splitNumber: 3,
                    axisLine: {
                        show: false, // Y轴线
                        lineStyle: {
                            color: 'rgba(85, 193, 255, 1)',
                        },
                    },
                    splitLine: {
                        lineStyle: {
                            type: 'dashed',
                            color: 'rgba(255,255,255,0.05)'
                        }
                    },
                    axisLabel: {
                        color: '#00FEFF',
                    },
                },
                series: data.series,
            }
            linechart.clear();
            linechart.setOption(option)
            window.addEventListener('resize', () => {
                linechart.resize()
            })
        },
    }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog {
    // background: #081D31;
    // background: rgba(0,0,0,0.6)!important;
    background: url(~@/assets/wms/history.png) !important;
    background-size: 100% 100% !important;
    border: none !important;
    opacity: 1;
    height: 4.5rem;

    .el-dialog__header {
        background: #153244;
        // height: .48rem;
    }

    .el-dialog__title,
    .el-dialog__headerbtn,
    .el-dialog__headerbtn>.el-dialog__close {
        color: #00FEFF;
        font-size: .23rem;
    }

    .el-dialog__body {
        padding: 0 !important;
    }
}

#lineChart {
    width: 100%;
    height: 4rem;
}
</style>